import React, { useState, useRef } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'

import "./accordion.css"

function Accordion(props) {

    const [setActive, setActiveState] = useState(props.active)
    const [setPlus, setPlusState] = useState(props.status)
    const [setHeight, setHeightState] = useState(props.status === false ? `${props.content.scrollHeight}px` : '0px')

    const content = useRef(null)

    function toggleAccordion() {
        setActiveState(setActive === "" ? "accordion-active" : "")
        setHeightState(setActive === "accordion-active" ? "0px" : `${content.current.scrollHeight}px`)
        setPlusState(setActive === "" ? false : true)
    }

    return (
        <div className="accordion_section">
            <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
                <p className="accordion_title">{props.title}{setPlus === false ? (<FontAwesomeIcon icon={faMinus} className={'tx-pink iconSmall'} />) : (<FontAwesomeIcon icon={faPlus} className={'tx-pink iconSmall'} />)}</p>
            </button>
            <div ref={content} style={{maxHeight: `${setHeight}`}} className="accordion_content">
                {props.content !== 'tabs' ? (<div 
                    className="accordion_text"
                    dangerouslySetInnerHTML={{ __html: props.content }}
                />) : (
                    <div className="sobreTabs investimentoTabs">
                        <div className="wrapperVencimento">
                            <label className="text-dark font-weight-bold titleVencimento">4 MESES:</label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Rentabilidade ao ano: <span className="text-dark">24%</span></label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Valor mínimo de entrada: <span className="text-dark">R$500,00</span></label>
                            <hr />
                            <label className="text-dark font-weight-bold titleVencimento">8 MESES:</label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Rentabilidade ao ano: <span className="text-dark">24%</span></label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Valor mínimo de entrada: <span className="text-dark">R$500,00</span></label>
                            <hr />
                            <label className="text-dark font-weight-bold titleVencimento">10 MESES:</label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Rentabilidade ao ano: <span className="text-dark">24%</span></label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Valor mínimo de entrada: <span className="text-dark">R$1.000,00</span></label>
                            <hr />
                            <label className="text-dark font-weight-bold titleVencimento">12 MESES:</label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Rentabilidade ao ano: <span className="text-dark">24%</span></label><br />
                            <label className="vencimentoInfo tx-pink font-weight-bold">Valor mínimo de entrada: <span className="text-dark">R$2.000,00</span></label>
                        </div>
                    </div>
                )}
                
            </div>
        </div>
    )
}

export default Accordion 